import {
  ghostBtnClass,
  mfgSecondaryBtnClass,
} from "@/components/manufacturing/manufacturingSurfaceClasses";
import type {
  BomAuthoringMember,
  BomMatchCandidate,
} from "@/lib/manufacturing/bomAuthoringSessionsClient";

function bandLabel(band: BomAuthoringMember["band"]): string {
  if (band === "high") return "Auto-attach";
  if (band === "ambiguous") return "Pick match";
  return "Placeholder";
}

function bandClass(band: BomAuthoringMember["band"]): string {
  if (band === "high") {
    return "bg-emerald-100 text-emerald-900 dark:bg-emerald-950/50 dark:text-emerald-100";
  }
  if (band === "ambiguous") {
    return "bg-amber-100 text-amber-950 dark:bg-amber-950/40 dark:text-amber-100";
  }
  return "bg-slate-100 text-slate-800 dark:bg-slate-800 dark:text-slate-100";
}

export function ManufacturingModelsBomSandboxMembers({
  members,
  onPickCandidate,
  onLeavePlaceholder,
}: {
  members: readonly BomAuthoringMember[];
  onPickCandidate: (index: number, candidate: BomMatchCandidate) => void;
  onLeavePlaceholder: (index: number) => void;
}) {
  return (
    <ul className="space-y-2">
      {members.map((m, idx) => (
        <li
          key={`${m.intent_name}-${idx}`}
          className="rounded-xl border border-slate-200 p-3 dark:border-slate-700"
        >
          <div className="flex flex-wrap items-center gap-2">
            <span className="font-medium text-slate-900 dark:text-slate-50">{m.intent_name}</span>
            <span className="text-xs text-slate-500">×{m.quantity}</span>
            <span
              className={`rounded-full px-2 py-0.5 text-xs font-medium ${bandClass(m.band)}`}
            >
              {bandLabel(m.band)}
            </span>
          </div>
          {m.band === "high" && m.auto_attach ? (
            <div className="mt-1 text-xs text-slate-600 dark:text-slate-300">
              → {m.auto_attach.kind}: {m.auto_attach.name} ({m.auto_attach.code})
            </div>
          ) : null}
          {m.band === "ambiguous" && m.candidates.length > 0 ? (
            <div className="mt-2 flex flex-wrap gap-2">
              {m.candidates.map((c) => (
                <button
                  key={`${c.kind}-${c.id}`}
                  type="button"
                  className={mfgSecondaryBtnClass}
                  onClick={() => onPickCandidate(idx, c)}
                >
                  {c.kind}: {c.name}
                </button>
              ))}
              <button
                type="button"
                className={ghostBtnClass}
                onClick={() => onLeavePlaceholder(idx)}
              >
                Leave placeholder
              </button>
            </div>
          ) : null}
          {m.band === "none" ? (
            <div className="mt-1 text-xs text-slate-500">
              Will stash as pending intent until matched or created as a child.
            </div>
          ) : null}
        </li>
      ))}
    </ul>
  );
}
